import { MODAL_LAYER as e } from "../layers.js";
import { cva as t } from "class-variance-authority";
// src/design/command-bar/styles.ts
var n = t([
	"flex items-center w-full gap-2 rounded-md cursor-pointer",
	"transition-all duration-fast ease-standard outline-hidden",
	"focus-ring"
], {
	variants: {
		variant: {
			default: ["bg-muted border border-border text-muted-foreground", "hover:bg-card"],
			outline: ["bg-transparent border border-border text-foreground", "hover:bg-muted"],
			ghost: ["bg-transparent border-0 text-muted-foreground", "hover:bg-muted"]
		},
		size: {
			sm: "px-2.5 py-1.5 text-sm",
			md: "px-3 py-2 text-sm",
			lg: "px-4 py-3 text-base"
		}
	},
	defaultVariants: {
		variant: "default",
		size: "md"
	}
}), r = t(["fixed inset-0 bg-scrim backdrop-blur-sm", e]), i = t(["fixed inset-0 flex items-start justify-center pt-20 px-4", e]), a = t(["relative w-full max-w-2xl bg-back", "border border-border rounded-lg shadow-overlay overflow-hidden"]), o = t(["w-full bg-transparent border-none outline-hidden", "text-foreground placeholder:text-muted-foreground"], {
	variants: { size: {
		sm: "px-3 py-1.5 text-sm",
		md: "px-4 py-3 text-sm",
		lg: "px-5 py-4 text-base"
	} },
	defaultVariants: { size: "md" }
}), s = t(["max-h-96 overflow-y-auto overflow-x-hidden py-2", "border-t border-border"]), c = t(["py-6 text-center text-sm text-muted-foreground"]), l = t(["overflow-hidden"]), u = t(["px-4 py-2 text-xs font-semibold text-muted-foreground", "uppercase tracking-wider"]), d = t([
	"flex items-center gap-3 cursor-pointer transition-all duration-fast",
	"outline-hidden",
	"data-[highlighted]:bg-muted",
	"data-[selected]:bg-secondary data-[selected]:text-primary",
	"data-[disabled]:opacity-50 data-[disabled]:cursor-not-allowed data-[disabled]:pointer-events-none"
], {
	variants: { size: {
		sm: "px-3 py-2 text-sm",
		md: "px-4 py-2.5 text-sm",
		lg: "px-5 py-3 text-base"
	} },
	defaultVariants: { size: "md" }
}), f = t(["w-4 h-4 shrink-0 text-muted-foreground"]), p = t(["flex-1 text-foreground"]), m = t(["ml-auto text-xs text-muted-foreground font-mono flex gap-1"]), h = t(["h-px bg-border my-2"]);
export { r as commandBarBackdropStyles, a as commandBarContentStyles, c as commandBarEmptyStyles, u as commandBarGroupHeadingStyles, l as commandBarGroupStyles, o as commandBarInputStyles, f as commandBarItemIconStyles, m as commandBarItemShortcutStyles, d as commandBarItemStyles, p as commandBarItemTextStyles, s as commandBarListStyles, i as commandBarPositionerStyles, h as commandBarSeparatorStyles, n as commandBarTriggerStyles };

//# sourceMappingURL=styles.js.map